import { firebaseApp } from "./init";
// import axios from "axios";
import store from "../store/index";
// import api from "../lib/api";
// import { config } from "../config/firebase";
export default function() {
  const user = store.getters["users/user"];
  const messaging = firebaseApp.messaging();
  if (user._id) {
    messaging.usePublicVapidKey(
      "BOGIP3njGtu_RJFf5fgm_D8swoABY1wEmFj9Q3d5D8UCtW4D9MrdplDZ_0K73EsKGZY9aKBbfygODcFMvfCFrZQ"
    );
    messaging
      .requestPermission()
      .then(function() {
        // console.log("Notification permission granted.");
        // console.warn(user);
        // TODO(developer): Retrieve an Instance ID token for use with FCM.
        // ...
      })
      .catch(function(err) {
        console.log("Unable to get permission to notify.", err);
      });

    messaging
      .getToken()
      .then(function(currentToken) {
        if (currentToken) {
          // sendTokenToServer(currentToken);
          // updateUIForPushEnabled(currentToken);
          // alert("token updated");
          // alert(currentToken);
          // alert(config.messagingSenderId);
          // alert(config.apiKey);
          // store
          //   .dispatch("users/token", {
          //     firebaseMsgToken: currentToken
          //   })
          //   .then(res => {
          //     window.location.reload();
          //   });
          // debugger;
          if (typeof user.firebase.notifyKey === "undefined") {
            store
              .dispatch("users/createGroup", {
                operation: "create",
                notification_key_name: user._id,
                registration_ids: [currentToken]
              })
              .then(res => {
                console.log("res from success create group");
                console.log(res);
              })
              .catch(err => {
                console.error(err);
              });
          } else {
            store.dispatch("users/addToGroup", {
              operation: "add",
              notification_key_name: user._id,
              notification_key: user.firebase.notifyKey,
              registration_ids: [currentToken]
            });
          }
          // axios
          //   .put(`${api()}/users/${user._id}`, {
          //     firebaseMsgToken: currentToken
          //   })
          //   .then(res => {
          //     console.warn("success token save");
          //     console.warn(res);
          //   })
          //   .catch(err => {
          //     console.error(err);
          //   });
        } else {
          // Show permission request.
          console.log(
            "No Instance ID token available. Request permission to generate one."
          );
          // Show permission UI.
          // updateUIForPushPermissionRequired();
          // setTokenSentToServer(false);
        }
      })
      .catch(function(err) {
        console.log("An error occurred while retrieving token. ", err);
        // showToken('Error retrieving Instance ID token. ', err);
        // setTokenSentToServer(false);
      });
    // Callback fired if Instance ID token is updated.
    messaging.onTokenRefresh(function() {
      messaging
        .getToken()
        .then(function(refreshedToken) {
          // Indicate that the new Instance ID token has not yet been sent to the
          // app server.

          // alert("token refresh", refreshedToken);
          // store
          //   .dispatch("users/token", {
          //     firebaseMsgToken: refreshedToken
          //   })
          //   .then(res => {
          //     window.location.reload();
          //   });

          store.dispatch("users/addToGroup", {
            operation: "add",
            notification_key_name: user._id,
            notification_key: user.firebase.notifyKey,
            registration_ids: [refreshedToken]
          });
          // setTokenSentToServer(false);
          // // Send Instance ID token to app server.
          // sendTokenToServer(refreshedToken);
          // ...
          // axios
          //   .put(`${api()}/users/${user._id}`, {
          //     firebaseMsgToken: refreshedToken
          //   })
          //   .then(res => {
          //     console.warn("success token save");
          //     console.warn(res);
          //   })
          //   .catch(err => {
          //     console.error(err);
          //   });
        })
        .catch(function(err) {
          console.log("Unable to retrieve refreshed token ", err);
          // showToken("Unable to retrieve refreshed token ", err);
        });
    });
  }
}
